<style scoped>
.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9;
  background: #000;
  opacity: .3;
}

.modal-alert {
  position: fixed;
  width: 800px;
  background: #fff;
  z-index: 9;
  left: 50%;
  top: 50%;
  margin-left: -400px;
  transform: translateY(-50%);
  padding-bottom: 20px;
}

.title-close {
  height: 50px;
  border-bottom: 1px solid #D9D9D9;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  font-size: 18px;
  color: #212121;
}
.title-close div{
  height: 100%;
  line-height: 50px;
}

.modal-alert .btns {
  width: 60px;
  height: 28px;
  background: #4FA1A4;
  border-radius: 2px;
  color: #fff;
  margin-top: 10px;
  float: right;
  margin-right: 20px;
  line-height: 28px;
  cursor: pointer;
  font-size: 14px;
}

.modal-alert .close {
  cursor: pointer;
  color: #909399;
}

.modal-alert .close:hover {
  color: #409EFF;
}

.modal-alert .tips {
  background: #FFFBF2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 4px;
  margin: 15px;
  text-align: left;
  padding: 10px 20px;
  line-height: 25px;

}

.modal-alert .sub-title {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin-left: 20px;
  display: flex;
  align-items: center;
}

.modal-alert .sub-title span {
  background: #4FA1A4;
  width: 4px;
  height: 16px;
  display: inline-block;
  margin-right: 8px;
}

.person-search {
  display: flex;
  padding-left: 30px;
  padding-top: 10px;
  align-items: center;
  color: #666;
}

.person-search .item1 {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.person-search .item1 .label {
  margin-right: 10px;
  word-break: keep-all;
}

.person-search .select-wrap {
  width: 250px;
}

/deep/ .table_header {
  background-color: #F0F0F0 !important;
  padding: 8px 0;
  color: #323233;
}

/deep/ .el-table td {
  padding: 8px 0px;
}
/deep/.el-input-number__decrease{
  height: 33px; 
  top:3px
}
/deep/ .el-input-number__increase{
  height: 33px; 
  top:3px
}

.table-wrap {
  margin: 20px;
  margin-top: 0;
}
.btns.cancel {
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
  color:#666;
}


 .search{
  display:flex;
  align-items:center;
  padding-left:20px;

}
 .input{
  background:none;
  outline:none;
  border:none;
  width:200px;
  height:32px;
  margin:10px;
  border: 1px solid rgba(217,217,217,1);
  border-radius: 2px;
  padding-left: 10px;
}
 .search .btn{
  background: #4FA1A4;
  border-radius: 2px;
  color:#fff;
  width:60px;
  height:28px;
  line-height:28px;
  text-align: center;
  margin-left:10px;
  border:1px solid transparent ;
  cursor: pointer;
} 
.search .btn.gray{
  border:1px solid #D9D9D9 ;
  color:#212121;
  background: #fff;
}
.search-sum{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  font-size: 14px;
}
</style>
<template>
  <div class="main" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="modal" @click="close"></div>
    <div class="modal-alert">
      <div class="title-close">
        <div class="title"  style="margin-bottom:0">人员明细</div>
        <i class="el-icon-close close" @click="close"></i>
      </div>
      <!-- <div class="tips">
        1、如果调整人员或者任务太多，请至【批量调整任务量】功能修改；<br>
        2、如果任务量改为0，则人员任务删除，无法继续执行此任务，移动端任务将不展示，请慎重修改
        总任务量：<span class="txt-color">{{detail.taskTotalType !='不限量'? taskDetail.taskTotal:'不限量' }}</span><span v-if="taskDetail.taskTotal">{{ taskDetail.taskTotalUnit }}</span>，已分解给
        <span class="txt-color">
          {{ taskDetail.taskDetailOrganisationList && taskDetail.taskDetailOrganisationList.length }}</span>个部门，<span class="txt-color">{{ taskDetail.staffTotal }}</span>个人员
        </div>
      </div> -->
      <div class="search-sum">
        <div class="sum">
          合计：共<span style="color:#4FA1A4;font-weight: bold;">{{staffTotal }}</span>人，总任务量：<span style="color:#4FA1A4;font-weight: bold;">{{detail.taskTotalType=='不限量'?'不限量': planCountTotal }}</span>
        </div>
        <div class="search">
            <div class="name">姓名</div>
            <input  class="input" v-model="page.staffName"  placeholder="请输入姓名"/>
            <div class="btn"  @click="search">搜索</div>
            <div class="btn gray" @click="emptySearch">清空</div>
        </div>
       
       </div>
      <div class="table-wrap">
        <el-table :data="detailData" max-height="500" stripe border header-cell-class-name="table_header">
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">{{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="人员名称" width="140" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="部门名称" width="220" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.organisationName || '-' }}</template>
          </el-table-column>

          <el-table-column label="计划量"  header-align="center" align="left">
            <template slot-scope="scope">{{detail.taskTotalType=='不限量'?'不限量': scope.row.planCount }}</template>
          </el-table-column>
          <el-table-column  label="实际完成量" width="120" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.realCount }}</template>
          </el-table-column>
          <el-table-column   label="实际完成率(%)" width="120" header-align="center" align="left">
              <template slot-scope="scope">{{ scope.row.finishRate }}</template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top:10px;    width: 680px" background @size-change="handleSizeChange" :pager-count="page.count"
          @current-change="handleCurrentChange" :page-sizes="[10]" :current-page="page.pageIndex"
          :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
        </el-pagination>
      </div>
      <div class="btns " @click="close">
        确定
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    detail: {
      type: Object,
      default: {},
    },
    projectManagerStaffList:{
      type: Array,
      default: []
    }
  },
  data() {
    return {
      fullscreenLoading:false,
      detailData:[],
      planCountTotal:0,
      staffTotal:0,
      tableHead:[],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        sourceTaskDetailGuid: null,
        staffName: '',
      }
    };
  },
  created() {
   this.getDetailList()
  },
  methods: {
    close() {
      this.$emit('close')
    },
    submit() {
      console.log(this.detail);
    },
    search(){
        this.page.pageIndex = 1;
        this.getDetailList();
      },
      emptySearch(){
        this.page.staffName = '';
        this.page.pageIndex = 1;
        this.getDetailList();
      },

    //查询明细
    getDetailList() {
      let projectManagerStaffList = this.projectManagerStaffList;
      let projectStaffGuidList = [];
      projectManagerStaffList.forEach(item=>{
        projectStaffGuidList.push(item.guid);
      })
      this.page.sourceTaskDetailGuid = this.detail.guid;
      this.page.projectStaffGuidList = projectStaffGuidList;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/project-staff-task-detail-execute`, this.page).then((res) => {
        this.fullscreenLoading = true;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.fullscreenLoading = false;
          this.detailData = res.data.data.pageData.records;
          this.page.totalPage = res.data.data.pageData.totalPages;
          this.page.totalRows = res.data.data.pageData.totalRows;
          this.planCountTotal = res.data.data.planCountTotal;
          this.staffTotal = res.data.data.staffTotal;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getDetailList();
    },
    handleCurrentChange(val) {
      this.page.pageIndex = val;
      this.getDetailList();
    },


  },
};
</script>